import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DatabaseService } from '../../services/database/database.service';
import { ToastService } from '../../services/toast/toast.service';
import { CommonModule } from '@angular/common';
import { Database } from '../../../models/database';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { response } from 'express';

@Component({
  selector: 'app-add-database-modal',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './add-database-modal.component.html',
  styleUrl: './add-database-modal.component.scss'
})
export class AddDatabaseModalComponent {
  @Output() saved = new EventEmitter<void>(); // Emit event when database is added
  dbForm!: FormGroup;
  showPassword = false;

  // selectedPlatformType: string = '';
  // showSnowflakeForm: boolean = false;
  // showMySQLPostgreSQLForm: boolean = false;

  constructor(
    private databaseService: DatabaseService,
    private fb: FormBuilder,
    private toastService: ToastService,
     public activeModal: NgbActiveModal,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.dbForm = this.fb.group({
      platform_name: ['', Validators.required],
      platform_type: ['', Validators.required],
      username: ['', Validators.required],
      password: ['', Validators.required],
      host: ['', Validators.required],
      warehouse: [''], // Only for Snowflake
      role: ['ACCOUNTADMIN'], // Only for Snowflake
      port: [''], // Only for MySQL/PostgreSQL
      database: [''],
    });
  }

  togglePasswordVisibility(){
    this.showPassword = !this.showPassword;
  }

  onPlatformTypeChange(): void {
    const platformType = this.dbForm.get('platform_type')?.value;

    // Reset optional fields when platform type changes
    this.dbForm.get('role')?.reset();
    this.dbForm.get('warehouse')?.reset();
    this.dbForm.get('port')?.reset();
    this.dbForm.get('database')?.reset();

    // Set validators based on platform type
    if (platformType === 'snowflake') {
      this.dbForm.get('warehouse')?.setValidators(Validators.required);
      this.dbForm.get('role')?.clearValidators();
    } else if (platformType === 'mysql' || platformType === 'postgres') {
      this.dbForm.get('database')?.setValidators(Validators.required);
      this.dbForm.get('port')?.clearValidators();
    }

    // Update validation status
    this.dbForm.get('warehouse')?.updateValueAndValidity();
    this.dbForm.get('role')?.updateValueAndValidity();
    this.dbForm.get('database')?.updateValueAndValidity();
    this.dbForm.get('port')?.updateValueAndValidity();
  }

  submitForm(): void {
    if (this.dbForm.valid) {
      const formData = this.dbForm.value;

      // Base payload with common fields
      console.log("DB_NAME:", formData.platform_name)
      const payload: Database = {
        platform_name: formData.platform_name,
        platform_type: formData.platform_type,
        connection_details: {
          host: formData.host,
          username: formData.username,
          password: formData.password,
        },
        last_tested: new Date().toISOString(),
        is_connected: false,
      };

      // Add platform-specific fields
      switch (formData.platform_type) {
        case 'snowflake':
          payload.connection_details.role = formData.role;
          payload.connection_details.warehouse = formData.warehouse;
          break;
        case 'mysql':
        case 'postgres':
          payload.connection_details.port = formData.port;
          payload.connection_details.database = formData.database;
          break;
      }
      const sessionID = sessionStorage.getItem('Session_Id')
      this.databaseService
        .addDatabase(formData.platform_name,payload)
        .pipe(
          catchError((error) => {
            this.toastService.showToast(`Error Adding Database with Error Code : ${error.error_code}`, {classname: 'bg-danger text-light'})
            return throwError(error);
          })
        )
        .subscribe({
          next: (response) => {
            this.toastService.showToast(`Database Added Successfully with Platform Type : ${response.platform_type}`, {classname: 'bg-success text-light'})
            this.saved.emit(); // Emit event to notify parent component
            this.dbForm.reset(); // Reset the form
            this.dismiss();
          },
        });
    }
  }

  showErrorModal(heading: string, message: string): void {

  }

  showSuccessModal(heading: string, message: string): void {

  }

  dismiss(): void {
    this.activeModal.dismiss();
  }
}

